module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.user) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.inactiveUser) ? _c('el-alert', {
    attrs: {
      "title": "Usuario Solicitado",
      "type": "warning",
      "description": "Los datos de alta han sido enviados y se encuentran en espera de confirmación",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.returnedUser) ? _c('el-alert', {
    attrs: {
      "title": "Usuario Devuelto",
      "type": "error",
      "description": "Los datos de alta han sido devueltos, por favor verifique y vuelva a enviarlos",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rowsModules), function(row) {
    return _c('el-row', {
      key: row.idModule,
      attrs: {
        "gutter": 12
      }
    }, _vm._l((row), function(fModule) {
      return (_vm.moduleVisible(fModule)) ? _c('el-col', {
        key: fModule.idModule,
        staticClass: "dashboard_block",
        attrs: {
          "xs": 24,
          "sm": 24,
          "md": 24 / row.length
        }
      }, [_c('el-card', {
        staticStyle: {
          "min-height": "350px"
        },
        attrs: {
          "shadow": "always",
          "align": "center"
        }
      }, [_c('p', [_c('strong', [_c('img', {
        staticClass: "alignnone wp-image-238 size-full",
        attrs: {
          "src": (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? fModule.html.imgEnabled : fModule.html.imgDisabled,
          "alt": "",
          "width": "91",
          "height": "91"
        }
      })])]), _vm._v(" "), _c('div', {
        class: (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? 'title' : 'title_disabled'
      }, [_vm._v(_vm._s(fModule.html.title))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "flex-direction": "column"
        }
      }, [_c('el-divider'), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "start",
          "align-items": "center",
          "flex-direction": "column"
        }
      }, [_c('div', _vm._l((fModule.html.links), function(link) {
        return _c('div', {
          key: link.title,
          staticStyle: {
            "display": "flex",
            "align-items": "center",
            "margin": "4px 0 4px 0"
          }
        }, [_c('router-link', {
          staticClass: "dashboardLink",
          staticStyle: {
            "display": "flex",
            "gap": "8px",
            "align-items": "center"
          },
          attrs: {
            "tag": (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? 'a' : 'span',
            "to": (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? link.route : ''
          },
          nativeOn: {
            "click": function($event) {
              return link.atClick.apply(null, arguments)
            }
          }
        }, [_c('svg', {
          staticStyle: {
            "shape-rendering": "geometricPrecision",
            "text-rendering": "geometricPrecision",
            "image-rendering": "optimizeQuality",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "version": "1.1",
            "width": "20",
            "height": "25",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "viewBox": "0 0 512 512"
          }
        }, [_c('g', [_c('path', {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "fill": "currentColor",
            "d": "M 232.5,-0.5 C 240.167,-0.5 247.833,-0.5 255.5,-0.5C 255.5,38.8333 255.5,78.1667 255.5,117.5C 255.5,142.167 255.5,166.833 255.5,191.5C 211.44,191.016 167.44,191.516 123.5,193C 115.606,196.561 110.106,202.395 107,210.5C 106.5,225.496 106.333,240.496 106.5,255.5C 106.062,271.557 106.562,287.557 108,303.5C 111.555,310.055 116.721,314.888 123.5,318C 167.44,319.484 211.44,319.984 255.5,319.5C 255.5,344.167 255.5,368.833 255.5,393.5C 255.5,432.833 255.5,472.167 255.5,511.5C 247.833,511.5 240.167,511.5 232.5,511.5C 132.727,498.549 61.5605,446.549 19,355.5C 8.86392,330.621 2.36392,304.954 -0.5,278.5C -0.5,263.167 -0.5,247.833 -0.5,232.5C 12.4486,132.729 64.4486,61.5622 155.5,19C 180.379,8.86392 206.046,2.36392 232.5,-0.5 Z"
          }
        })]), _c('g', [_c('path', {
          staticStyle: {
            "opacity": "0.998"
          },
          attrs: {
            "fill": "currentColor",
            "d": "M 255.5,-0.5 C 263.167,-0.5 270.833,-0.5 278.5,-0.5C 378.271,12.4486 449.438,64.4486 492,155.5C 502.136,180.379 508.636,206.046 511.5,232.5C 511.5,247.833 511.5,263.167 511.5,278.5C 498.551,378.271 446.551,449.438 355.5,492C 330.622,502.136 304.955,508.636 278.5,511.5C 270.833,511.5 263.167,511.5 255.5,511.5C 255.5,472.167 255.5,432.833 255.5,393.5C 261.71,405.185 270.71,407.685 282.5,401C 329.03,355.469 375.863,310.303 423,265.5C 426.293,261.093 427.127,256.427 425.5,251.5C 422.887,245.372 418.887,240.205 413.5,236C 370.197,195.031 327.197,153.697 284.5,112C 272.73,103.239 263.063,105.072 255.5,117.5C 255.5,78.1667 255.5,38.8333 255.5,-0.5 Z"
          }
        })]), _c('g', [_c('path', {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "fill": "#fefefe",
            "d": "M 425.5,251.5 C 425.5,252.833 425.5,254.167 425.5,255.5C 319.167,255.5 212.833,255.5 106.5,255.5C 106.333,240.496 106.5,225.496 107,210.5C 110.106,202.395 115.606,196.561 123.5,193C 167.44,191.516 211.44,191.016 255.5,191.5C 255.5,166.833 255.5,142.167 255.5,117.5C 263.063,105.072 272.73,103.239 284.5,112C 327.197,153.697 370.197,195.031 413.5,236C 418.887,240.205 422.887,245.372 425.5,251.5 Z"
          }
        })]), _c('g', [_c('path', {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "fill": "#ddddde",
            "d": "M 425.5,251.5 C 427.127,256.427 426.293,261.093 423,265.5C 375.863,310.303 329.03,355.469 282.5,401C 270.71,407.685 261.71,405.185 255.5,393.5C 255.5,368.833 255.5,344.167 255.5,319.5C 211.44,319.984 167.44,319.484 123.5,318C 116.721,314.888 111.555,310.055 108,303.5C 106.562,287.557 106.062,271.557 106.5,255.5C 212.833,255.5 319.167,255.5 425.5,255.5C 425.5,254.167 425.5,252.833 425.5,251.5 Z"
          }
        })])]), _vm._v(" "), _c('div', [_c('span', {
          class: (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? '' : 'link_title_disabled',
          staticStyle: {
            "vertical-align": "top"
          },
          attrs: {
            "data-cy": 'lnk_' + link.title
          }
        }, [_vm._v(_vm._s(link.title))]), _vm._v(" "), ((!link.badgeHiddenCond && _vm.userHasModule(fModule)) && (fModule.html.inactiveCompany || !_vm.inactiveUser) && link.route != '/allComments') ? _c('el-badge', {
          attrs: {
            "hidden": link.badgeHiddenCond,
            "value": link.badgeValue,
            "max": 99
          }
        }) : _vm._e(), _vm._v(" "), ((!_vm.badgeChatHidden && _vm.userHasModule(fModule)) && (fModule.html.inactiveCompany || !_vm.inactiveUser) && (link.route == '/allComments')) ? _c('el-badge', {
          attrs: {
            "hidden": _vm.badgeChatHidden,
            "value": _vm.badgeChatValue,
            "max": 99
          }
        }) : _vm._e()], 1)]), _vm._v(" "), _c('br')], 1)
      }), 0)])], 1)])], 1) : _vm._e()
    }), 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-80px"
    },
    attrs: {
      "title": "Política de Pagos",
      "visible": _vm.showModalPaymentPolicies,
      "width": "85%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalPaymentPolicies = $event
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 233px)"
    },
    attrs: {
      "src": _vm.urlPaymentPolicies
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalPaymentPolicies = false
      }
    }
  }, [_vm._v("\n        Cerrar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-80px"
    },
    attrs: {
      "title": "Política de Compras",
      "visible": _vm.showModalBuyPolicies,
      "width": "85%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalBuyPolicies = $event
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 233px"
    },
    attrs: {
      "src": _vm.urlBuyPolicies
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalBuyPolicies = false
      }
    }
  }, [_vm._v("\n        Cerrar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-80px"
    },
    attrs: {
      "title": "Código de Conducta",
      "visible": _vm.showModalEthicsPolicies,
      "width": "85%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalEthicsPolicies = $event
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 233px)"
    },
    attrs: {
      "src": _vm.urlEthicsPolicies
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "data-cy": "btn-cc-cerrar"
    },
    on: {
      "click": function($event) {
        _vm.showModalEthicsPolicies = false
      }
    }
  }, [_vm._v("\n        Cerrar\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71fc1da4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 640
// module chunks = 1